import type { CommissionStatementFileDto } from 'korint-sdk';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';
import { FileButton } from './FileButton';

export function TransferFilesButton({ files }: { files: CommissionStatementFileDto[] }) {
  const { t } = useTranslation();

  if (files.length <= 1) {
    return <FileButton format="XML" file={files[0]} />;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          XML <ChevronDown className="ml-1 size-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {files.map((file, index) => (
          <DropdownMenuItem key={file.name} asChild>
            <a href={file.signedUrl} download={file.name}>
              {t('commissions.monthly.transferFile', { index: index + 1, count: files.length })}
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
